/** HTTP status codes used in the parquet server handler */
export const StatusCode = {
  Ok: 200, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/200>
  PartialContent: 206, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/206>
  NotModified: 304, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/304>
  BadRequest: 400, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/400>
  Unauthorized: 401, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401>
  NotFound: 404, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/404>
  MethodNotAllowed: 405, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/405>
  RequestTimeout: 408, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/408>
  Gone: 410, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/410>
  PreconditionFailed: 412, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/412>
  RangeNotSatisfiable: 416, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/416>
  InternalServerError: 500, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/500>
  GatewayTimeout: 504, // <https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/504>
} as const;
